module.exports = __webpack_public_path__ + "img/guidancenetwork-logo-white.059ffba6.png";